import { useState, useEffect } from 'react';
const defaultState = {
  loaded: false,
  loading: true,
  error: false,
  image: undefined
};
/**
 * Creates and `img` element with options provided
 * @param url Image source URL
 * @param config Options for `img`
 * @returns an object containing the `img` element and flags indicating load and error states
 * @see Avatar Tile
 */
export default function useImage(url, config) {
  const [{
    image,
    loaded,
    loading,
    error
  }, setState] = useState(defaultState);
  useEffect(function () {
    if (!url) return;
    const img = document.createElement('img');
    function onload() {
      setState({
        image: img,
        loaded: true
      });
    }
    function onerror() {
      setState({
        error: true
      });
    }
    img.addEventListener('load', onload);
    img.addEventListener('error', onerror);
    if (config) {
      Object.assign(img, config);
    }
    img.src = url;

    // eslint-disable-next-line consistent-return
    return function () {
      img.removeEventListener('load', onload);
      img.removeEventListener('error', onerror);
      setState(defaultState);
    };
  }, [url, config]);
  return {
    image,
    loaded,
    loading,
    error
  };
}
//# sourceMappingURL=useImage.js.map